'use client'

import React from 'react'
import TruevoCheckout, { TruevoResponse } from '../truevoCheckout'

interface TruevoMethodProps {
  truevoCheckoutKey: number
  amount: number
  currencyCode?: string
  customerInfo: {
    firstName?: string
    lastName?: string
    email?: string
    phone?: string
    address?: Record<string, string>
  }
  formValid: boolean
  renderValidationWarning: () => React.ReactNode
  onTransactionCompleted: (response: TruevoResponse) => void
  onTransactionDeclined: (response: TruevoResponse) => void
  onTransactionFailed: (response: TruevoResponse) => void
}

export default function TruevoMethod({
  truevoCheckoutKey,
  amount,
  currencyCode = 'EUR',
  customerInfo,
  formValid,
  renderValidationWarning,
  onTransactionCompleted,
  onTransactionDeclined,
  onTransactionFailed,
}: TruevoMethodProps) {
  if (!formValid) {
    return <>{renderValidationWarning()}</>
  }

  return (
    <TruevoCheckout
      key={truevoCheckoutKey}
      amount={amount}
      currencyCode={currencyCode}
      customerInfo={customerInfo}
      onTransactionCompleted={onTransactionCompleted}
      onTransactionDeclined={onTransactionDeclined}
      onTransactionFailed={onTransactionFailed}
    />
  )
} 